import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsVelomobileNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M25.498 34h-3.526c-3.115 0-6.189-.712-8.986-2.08a6.488 6.488 0 01-1.74 4.021A6.5 6.5 0 01.019 32H0V14.607c0-.553.277-1.138.845-1.463C1.68 12.665 5.188 11 13.5 11c7.69 0 15.412 2.301 21.566 5.594 6.078 3.253 10.946 7.652 12.494 12.077.533 1.523.061 2.945-.889 3.907-.906.92-2.225 1.422-3.56 1.422h-5.61a6.502 6.502 0 01-12.003 0zM7.63 14.35c-2.391.317-3.859.782-4.63 1.09V27h2.028c3.174 0 6.304.739 9.143 2.158A17.445 17.445 0 0021.972 31h3.047a6.5 6.5 0 0112.962 0h5.13c.621 0 1.142-.241 1.425-.528.239-.243.306-.488.193-.81-1.173-3.353-5.22-7.287-11.079-10.423a41.308 41.308 0 00-.175-.093L30.621 22H13.24zm2.276 16.346A17.442 17.442 0 005.028 30h-1.69a3.5 3.5 0 106.568.696zM31.5 28a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM11.13 14.05L14.76 19H29.38l1.236-1.236C25.433 15.484 19.427 14 13.5 14c-.845 0-1.634.018-2.37.05z"
        fill=""
      />
    </svg>
  )
);
SvgSportsVelomobileNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsVelomobileNormalLarge;
